import { ApiService } from "../../../config";
import type { IConcorrentes, IEstimativaDeMercado, IHistoricoDePosicoes } from "../types";

const buscar = async <T>(caminho: string, params?: Record<string, unknown>): Promise<T | null> => {
  try {
    const response = await ApiService.get(caminho, params ? { params } : undefined);
    const { data, error } = response.data;
    return error ? null : (data as T);
  } catch {
    return null;
  }
};

const getHistoricoDePosicoes = (profileId: string, months = 12) =>
  buscar<IHistoricoDePosicoes>(`/dashboard/profile/${profileId}/positions-history`, { months });

const getConcorrentes = (profileId: string) =>
  buscar<IConcorrentes>(`/dashboard/profile/${profileId}/competitors`);

const getEstimativaDeMercado = (profileId: string) =>
  buscar<IEstimativaDeMercado>(`/dashboard/profile/${profileId}/market-estimate`);

export const RelatorioService = {
  getHistoricoDePosicoes,
  getConcorrentes,
  getEstimativaDeMercado,
};
